<template>
  <v-simple-table class="elevation-0 mb-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-left">RESPONSABILIDADE</th>
          <th class="text-center">RESULTADO</th>
          <th class="text-center">RESULTADO MÁXIMO</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="indicacao in indicacoesDesenvolvimento" :key="indicacao.id">
          <td width="5%">
            <v-icon color="error"> trending_up </v-icon>
          </td>
          <td width="30%">
            <span class="grey--text text--darken-2">{{
              indicacao.responsabilidade.titulo
            }}</span>
          </td>
          <td class="text-center" width="10%">
            <span class="error--text">
              <strong>{{ indicacao.notaAgrupada | decimal }}</strong>
            </span>
          </td>
          <td class="text-center" width="10%">
            <span class="grey--text text--darken-2">
              <strong>{{ indicacao.notaMaxima | decimal }}</strong>
            </span>
          </td>
        </tr>
        <tr>
          <td class="text-center" colspan="6">
            <v-row class="justify-center">
              <v-col>
                <v-icon class="ml-8 mr-2" color="error"> trending_up </v-icon>
                Indicação de Desenvolvimento
              </v-col>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'AppIndicacaoResponsabilidade',

  props: {
    indicacoesDesenvolvimento: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
